/* JYM flavor pills — hold the row's scroll position through Impact's variant re-render.
   Impact rebuilds the option row on product:rerender, which resets a horizontally scrolling row to
   scrollLeft 0. We remember the row's position the moment a pill is tapped and restore it synchronously
   as soon as the new row exists, so nothing animates from the start. Only if the tapped pill is still
   outside the box do we nudge it into view. */
(function () {
  var remembered = null;   // { left, value }

  function rowOf(el) { return el && el.closest ? el.closest('.variant-picker__option-values') : null; }
  function flavorRow() {
    var pill = document.querySelector('.variant-picker__option-values .block-swatch--flavor');
    return rowOf(pill);
  }

  // 1. Remember where the row was when the shopper tapped.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    var row = rowOf(t);
    if (!row || !row.querySelector('.block-swatch--flavor')) return;
    remembered = { left: row.scrollLeft, value: t.value };
  }, true);

  // 2. Restore instantly once the re-rendered row is in the DOM (no smooth scroll from 0).
  function restore() {
    var row = flavorRow();
    if (!row || !remembered) return;
    if (row.scrollWidth <= row.clientWidth + 1) return;          // desktop wrap: nothing to restore
    if (Math.abs(row.scrollLeft - remembered.left) > 1) row.scrollLeft = remembered.left;
    var checked = row.querySelector('input:checked + .block-swatch--flavor');
    if (checked) {
      var r = checked.getBoundingClientRect(), b = row.getBoundingClientRect();
      if (r.left < b.left || r.right > b.right) {
        row.scrollLeft = checked.offsetLeft - (row.clientWidth - checked.offsetWidth) / 2;
      }
    }
  }
  document.addEventListener('product:rerender', function () { restore(); requestAnimationFrame(restore); });
  document.addEventListener('variant:change', function () { restore(); requestAnimationFrame(restore); });
})();
